import script from "./SimpleNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SimpleNavigation.vue?vue&type=style&index=0&id=a912b254&lang=scss"

const __exports__ = script;

export default __exports__